/*jslint node: true */
/*globals location, dataLayer */

'use strict';

import axios from 'axios';
import Token from '../modules/token.js';
import Dashboard from '../components/Dashboard.vue';
import Login from '../components/Login.vue';
import User from '../components/User.vue';
import Messages from '../components/Messages.vue';
import AddCar from '../components/AddCar.vue';
import Cars from '../components/Cars.vue';
import Events from '../components/Events.vue';
import CarSearches from '../components/CarSearches.vue';
import Tradeplan from '../components/Tradeplan.vue';
import Articles from '../components/Articles.vue';
import Feedback from '../components/Feedback.vue';
import Vouchers from '../components/Vouchers.vue';
import AddTestdriveReport from '../components/AddTestdriveReport.vue';

module.exports = {
  routes: [{
      name: 'dashboard',
      path: '/',
      component: Dashboard
    },
    {
      name: 'register',
      path: '/rekisteroidy',
      component: Login
    },
    {
      name: 'getactivationlink',
      path: '/tilaa-aktivointilinkki',
      component: Login
    },
    {
      name: 'dashboard-children',
      path: '/etusivu/:section',
      component: Dashboard
    },
    {
      name: 'user',
      path: '/omat-tiedot',
      component: User
    },
    {
      name: 'messages',
      path: '/viestit',
      component: Messages
    },
    {
      name: 'messages-types',
      path: '/viestit/:type',
      component: Messages
    },
    {
      name: 'messages-message',
      path: '/viestit/:type/:id',
      component: Messages
    },
    {
      name: 'events',
      path: '/asiointihistoria',
      component: Events
    },
    {
      name: 'cars',
      path: '/omat-autot',
      component: Cars
    },
    {
      name: 'cars-children',
      path: '/omat-autot/:license',
      component: Cars
    },
    {
      name: 'cars-children-section',
      path: '/omat-autot/:license/:section',
      component: Cars
    },
    {
      name: 'add-car',
      path: '/lisaa-auto',
      component: AddCar
    },
    {
      name: 'searches',
      path: '/hakuvahdit',
      component: CarSearches
    },
    {
      name: 'tradeplan',
      path: '/vaihtosuunnitelma',
      component: Tradeplan
    },
    {
      name: 'articles',
      path: '/tuulilasi-artikkelit',
      component: Articles
    },
    {
      name: 'addtestdrivereport',
      path: '/lisaa-koeajoraportti/:id',
      component: AddTestdriveReport
    },
    {
      name: 'feedback',
      path: '/palaute',
      component: Feedback
    },
    {
      name: 'vouchers',
      path: '/etusi',
      component: Vouchers
    },
    {
      name: 'logout',
      path: '/kirjaudu-ulos',
      component: function () {
        Token.getToken(token => {
          axios
            .post('/ajax/logout/?cm_lang=fi_FI', {
              token: token
            })
            .then(response => {
              if (response.data.success) {
                dataLayer.push({
                  UserLoggedIn: false
                });
                location.reload();
                let state = this.$store.state;
                let newState = {};

                Object.keys(state)
                  .forEach(key => {
                    newState[key] = null; // or = initialState[key]
                  });

                this.$store.replaceState(newState);
              }
            })
            .catch(error => {});
        });
      }
    }
  ]
};
